// =========================================================================================@@
// Last Updated Date: May 26, 2025
// Last Updated By: Steven Yuen
// Status Level: 2
// ===========================================================================================

import React from 'react'
import { AddressBook, CalendarBlank, ChatCentered, House, Newspaper, Users } from '@phosphor-icons/react'
import PropTypes from 'prop-types'

const iconMap = {
   blog: Newspaper,
   directory: AddressBook,
   discussions: ChatCentered,
   events: CalendarBlank,
   groups: Users,
   home: House,
   latest: Newspaper
}

const NavButtonIcon = ({ icon }) => {
   const Icon = iconMap[icon || 'home']

   return (
      <Icon size={20} className="opacity-50" />
   )
}

NavButtonIcon.propTypes = {
   icon: PropTypes.string.isRequired
}

const determineSelectedMenuLink = (links, currentLocationPathname) => {
   let indexOfLinkWithLongestMatch = -1

   links.forEach((link, i) => {
      if (currentLocationPathname.startsWith(link.url)) {
         if (indexOfLinkWithLongestMatch > -1) {
            if (link.url.length > links[indexOfLinkWithLongestMatch].url.length) {
               indexOfLinkWithLongestMatch = i
            }
         } else {
            indexOfLinkWithLongestMatch = i
         }
      }
   })

   return indexOfLinkWithLongestMatch
}

export { determineSelectedMenuLink, NavButtonIcon }
